<template>
 <div>
   <div id="index">
     <div class="body between">
       <div class="logo">
         <img :src="logo">
       </div>
       <div class="nav">
         <div @click="tabact(item.id)" :class="index<2?'nav_box borderRight':'nav_box'" v-for="(item,index) in navList">
           <a :href="item.id" :class="activeId==item.id?'act':''">{{item.title}}</a>
         </div>
       </div>
     </div>
   </div>
   <div class="banner" id="banner">
        <img class="bannerimg" :src="banner"/>
<!--     <div class="body">-->
<!--       <img class="erweima" :src="erweima" slot="二维码"/>-->
<!--     </div>-->
   </div>
   <div class="body">
     <div class="tab">
       <div class="tabList" v-for="item in tabList">
         <div><img :src="item.img"></div>
         <div class="text">{{item.text}}</div>
       </div>
     </div>
     <div class="fw">
       <div class="tit">
         菜小呆服务
       <div class="borderbottom"></div>
       </div>
       <div>
         让美食像自来水一样，触手可得！惠及万千学子。
       </div>
     </div>
     <div class="slogn between">
       <div class="left">
         <div class="slognList flexstart" v-for="item in slogn">
           <div class="iconImg">
             <img :src="item.icon">
           </div>
           <div class="slognText">{{item.text}}</div>
         </div>
       </div>
       <div class="right">
         <img :src="phone">
       </div>
     </div>
     <div class="about" id="about">
       <div class="tit">
         <div class="ts">ABOUTUS</div>
         关于我们
       </div>
       <div class="cp">
         <div class="cpList" v-for="item in cpList">
           <img :src="item.cpimg" />
           <div>
             {{item.text}}
           </div>
         </div>
       </div>
     </div>
     <div class="download" id="download">
       <div class="tit">
         <div class="ts">DOWNLOAD</div>
         客户端下载
       </div>
       <div class="load">
         <div class="bgimg">
           <img :src="bg"/>
         </div>
         <div class="lists">
           <div class="gz">
             <img :src="jiazi" />
             <img :src="jiazi" />
           </div>
           <div class="list" style="border-bottom: 1px dashed #FAB33F;">
             <div class="left">
               <img class="logo" :src="logo_sj" />
<!--               <img  id="qrcode2" style="padding-left: 20px" src="http://192.168.1.15:18092/version/test" />-->
               <div class="">
                 <div class="t">
                   菜小呆商家版
                 </div>
                 <div class="s">
                   手机接单，快速管理店铺，上架商品，查看数据
                 </div>
                 <div class="l">
                   <p>订单来了，语音播放</p>
                   <p>随时随地，快捷管理</p>
                 </div>
               </div>
             </div>
             <div class="down">
               <div class="android">
                 <img class="code" v-show="shopCode" src="http://cxd-prod-api.andouyou.com/users/version/getShopCode">
                 <button @mouseenter="shopCode=true" @mouseleave="shopCode=false">
                   Android下载
                 </button>
               </div>
               <div class="ios">
                 <img v-show="false" :src="logo_sj">
                 <button @click="atention">
                   IOS下载
                 </button>
               </div>
             </div>
           </div>
           <div class="list">
             <div class="left">
               <img class="logo" :src="logo_ps" />
               <div class="">
                 <div class="t">
                   菜小呆配送端
                 </div>
                 <div class="s">
                   骑手接单App，来单自动提示，快速抢单，完成取货，配送等流程
                 </div>
                 <div class="l">
                   <p>快速抢单，快速配送</p>
                   <p>订单结算，金额提现</p>
                 </div>
               </div>
             </div>
             <div class="down">
               <div class="android">
                 <img class="code" v-show="delive" src="http://cxd-prod-api.andouyou.com/users/version/getDeliveryCode">
                 <button @mouseenter="delive=true" @mouseleave="delive=false">
                   Android下载
                 </button>
               </div>
               <div class="ios">
                 <img v-show="false" :src="logo_ps">
                 <button @click="atention">
                   IOS下载
                 </button>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>

   </div>
   <div class="footer">
     <div class="body" style="position: relative">
     <div class="left">
       <div class="tit">
         商务合作咨询热线：‭021-61732097‬
       </div>
       <div class="add">
         公司地址：上海嘉定区江桥镇西郊商务区C2区1555弄33号楼
       </div>
       <div class="bei">
         Copyright2020-2025 菜小呆 沪ICP备17017242
       </div>
     </div>
     <div class="img">
       <img :src="gzh" slot="菜小呆公众号" />
       <div>菜小呆公众号</div>
     </div>
   </div>
   </div>
 </div>
</template>
<script>
    import logo from '@/assets/image/logo.png';
    import logo_sj from '@/assets/image/logo_sj.png';
    import logo_ps from '@/assets/image/logo_ps.png';
    import banner from '@/assets/image/banner.png';
    import tab1 from '@/assets/image/tab1.png';
    import tab2 from '@/assets/image/tab2.png';
    import tab3 from '@/assets/image/tab3.png';
    import cp1 from '@/assets/image/cp1.png';
    import cp2 from '@/assets/image/cp2.png';
    import cp3 from '@/assets/image/cp3.png';
    import icon1 from '@/assets/image/icon1.png';
    import icon2 from '@/assets/image/icon2.png';
    import icon3 from '@/assets/image/icon3.png';
    import icon4 from '@/assets/image/icon4.png';
    import phone from '@/assets/image/phone.png';
    import erweima from '@/assets/image/erweima.jpg';
    import bg from '@/assets/image/bg.png';
    import jiazi from '@/assets/image/jiazi.png';
    import gzh from '@/assets/image/gzh.jpg';
    export default {
        name: "index",
        data(){
            return {
              delive:false,
              shopCode:false,
              activeId:"#banner",
              logo:logo,
              logo_sj:logo_sj,
              logo_ps:logo_ps,
              banner:banner,
              phone:phone,
              jiazi:jiazi,
              erweima:erweima,
                gzh:gzh,
                bg:bg,
              navList:[
                  {
                      title:"首页",
                      id:"#banner",
                  },
                  {
                      title:"关于我们",
                      id:"#about"
                  },
                  {
                      title:"客户端下载",
                      id:"#download"
                  }
              ],
              tabList:[
                  {
                      img:tab1,
                      text:"互联网外卖"
                  },
                  {
                      img:tab2,
                      text:"万能跑腿服务"
                  },
                  {
                      img:tab3,
                      text:"本地生活服务"
                  },
              ],
              slogn:[
                  {
                      icon:icon1,
                      text:"致力于打造校园专属的020外送平台"
                  },
                  {
                      icon:icon2,
                      text:"旨在给用户提供便捷的线上外卖平台"
                  },
                  {
                      icon:icon3,
                      text:"未来会拓展其他懒人服务"
                  },
                  {
                      icon:icon4,
                      text:"全面打造便捷、安全的智能校园生活服务平台。"
                  }
              ],
              cpList:[
                  {
                      cpimg:cp1,
                      text:"上海先瀛网络科技有限公司成立于2018年，在”爱·感恩·责任”的企业文化中，始终坚持以客户为中心。"
                  },
                  {
                      cpimg:cp2,
                      text:"“菜小呆”是先瀛主要经营的高校校园生活服务平台，为全国大学生提供懒人服务。在迈向全国高校的路途中，我们着重挖掘和培养人才，创造发展空间，持续提升伙伴价值，提高工作和生活质量。为工作伙伴提供实现价值、财务自由和梦想的平台。"
                  },
                  {
                      cpimg: cp3,
                      text: "总公司上海诸宸实业有限公司成立于2004年10月，年营业收入约8亿元。目前为止是华东、华北地区沃尔玛最大生鲜供应商之一，且全面入驻华东地区大润发家乐福、世纪联华、易初莲花等商超，同时给上海各大政府食堂以及园区食堂优质食材供应。"
                  }
                  ],
                deliveryAppUrl:undefined,
                shopAppUrl:undefined
            }
        },

        created:function () {
            if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
                this.$router.push({path:"mobile"});
               }else {
                console.log(2)
            }
            // this.getCode();
        },
        methods:{
            tabact(e){
               this.activeId=e;
            },
            atention(){
              alert("IOS版本正在路上！敬请期待");
            },

        }
    }
</script>
<style scoped>
  /*.download{*/
  /*  position: relative;*/
  /*}*/
  #banner{
    padding-top:80px;
  }
.tit div{
    position: absolute;
    top: -50px;
    left: 0;
    text-align: center;
    right: 0;
    font-size: 134px;
    font-weight: bold;
    color: #FFD261;
    opacity: 0.1;
  }
  .tit{
    position: relative;
  }
  .load .code{
    position: absolute;
    z-index: -1;
    top: 10px;
    left: -26px;
    width: 120px;
    height: 120px;
    padding: 20px;
    display: block;
    background: rgba(0,0,0,0.6);
    border-radius: 10px;
  }
  .nav a.act{
    color: #FFB600;
  }
  .footer{
    position: relative;
    text-align: center;
    color: #999;
    font-size: 12px;
    line-height: 25px;
    width: 100%;
    margin: 0 auto;
    padding-top: 20px;
    height: 176px;
    background: #F8F8F8;
  }
  .footer .tit{
    color: #333333;
    margin-top: 20px;
    font-size: 20px;
    margin-bottom: 30px;
  }
  .footer img{
    width: 100px;
    height: 100px;
  }
  .footer .img{
    position: absolute;
    top: 0px;
    right: 76px;
    text-align: center;
    width: 100px;
    font-size: 14px;
  }
  .load .down{
    position: relative;
    margin-right: 50px;
    width: 400px;
    padding-top: 177px;
    display: flex;
    justify-content: flex-end;
  }
  .load .down  button{
    display: inline-block;
    margin-left: 50px;
    width: 200px;
    height: 50px;
    border-radius: 10px;
    text-align: center;
    color: #333;
    font-size:18px;
    border: none;
    background: #FFD261;
  }
  .load .down .ios, .load .down .android{
    width: 200px;
    height: 50px;
    margin-right: 50px;
  }
  .load .down .android{
    margin-right: 50px;
  }
  .load .down .ios button{
    background: #8DBCFF;
  }
  .load .down .ios button:hover{
    background: #5393EF;
  }
  .load .down .ios:hover img{
    display: block;
  }
  .load .down .android:hover img{
    display: block;
  }
  .load .down .android button{
    background: #FFD261;
  }
  .load .down .android button:hover{
    background: #FFB600;
  }

  .load .left .t{
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
  }
  .load .left .s{
    margin-top: 20px;
    font-size: 16px;
  }
  .load .left .l{
    margin-top: 30px;
    font-size: 14px;
    color: #FFB600;
    line-height: 20px;
  }
  .load{
    color: #333333;
    padding-top: 1px;
  }
  .load .lists{
    margin-top: 94px;
    width: 1200px;
    height: 556px;
    border: 10px solid #FFD261;
    margin-bottom: 30px;
  }
  .load .lists .gz{
    display: flex;
    justify-content: space-around;
    margin-top: -104px;
  }
 .load .list{
   display: flex;
   justify-content: space-between;
 }
  .load .left{
    margin: 50px 0 50px 50px;
    display: flex;
    justify-content: flex-start;
  }
  .load .left .logo{
    width: 160px;
    height: 160px;
    border-radius: 10px;
    margin-right: 50px;
  }
  .about{
    text-align: center;
  }
  .about .tit,.download  .tit{
    color: #FFB600;
    font-size: 60px;
    font-weight: bold;
    margin: 180px auto;
    text-align: center;
  }
  .download .bgimg{
    z-index: -1;
    position: absolute;
    left: 0;
    width: 100%;
    height: 700px;
  }
  .bgimg img{
    width: 100%;
    height: 700px;
  }
  .about .cp {
    display: flex;
    justify-content: space-around;
  }
  .about .cpList{
    text-align: center;
    padding-top: 40px;
    width: 300px;
    height: 460px;
    background: #FFFFFF;
    box-shadow: 1px 4px 18px 0px rgba(255, 215, 114, 0.43);
  }
  .cpList div{
    width: 185px;
    margin: 35px auto;
    text-align: left;
    color: #333;
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
  }
  .slogn{
    font-weight: bold;
    color: #333333;
    font-size: 30px;
  }
  .slogn .left{
    /*margin: 70px 0 20px 0;*/
  }
  .slogn .left .slognList{
     height: max-content;
     margin: 70px 0 20px 0;
  }
  .slognText{
    vertical-align: text-after-edge;
    line-height: 80px;
  }
  .slogn .left .iconImg{
    text-align: left;
    width: 135px;
  }
  .fw{
    margin-top: 150px;
    height: max-content;
    color: #8C8C8C;
    font-size: 36px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .fw .tit{
    font-size: 40px;
    margin-bottom: 20px;
    color: #000000;
    line-height: 40px;
    height: 60px;
    width: 224px;

  }
  .fw .tit .borderbottom{
    width: 100%;
    height: 6px;
    margin-top: 16px;
    border-radius: 3px;
    background:#FFD261;
  }
 #index{
   background: #fff;
   position: fixed;
   top:0;
   left: 0;
   right: 0;
   width: 100%;
   height: 80px;
   line-height: 80px;
   color:#333333;
   font-size: 16px;
   margin: 0 auto;
   z-index: 10;
   box-shadow: 0 3px 6px 0 rgba(67,67,67,0.14);
   /*border-bottom: 1px solid #FFB600;*/
 }
 .nav{
   height:18px;
   line-height: 18px;
   margin: 31px 0;
   display: flex;
   justify-content: flex-end;
 }
 .nav div{
   padding:0 30px;
 }
 .nav a{
   text-decoration: none;
   color: #333;
 }
 .nav a:hover{
   color: #FFB600;
 }
 .nav .borderRight{
   border-right: 2px solid #cccccc;
 }
.between{
  display: flex;
  justify-content: space-between;
}

.logo,.logo img{
  width:190px;
  height: 63px;
  margin-top: 4px;
}
.banner{
  /*margin-top: 80px;*/
  width: 100%;
  height: auto;
  position: relative;
}
.banner .bannerimg{
  width: 100%;
  height:  auto;
  position: relative;
  top: 0;
  z-index: -1;
}
.banner .body{
  position: absolute;
  bottom: 125px;
  margin: 0 auto;
  left: 0;
  right: 0;
}
.banner .erweima{
  width: 150px;
  height: 150px;
  border-radius: 20px;

}
.flexstart{
  display: flex;
  justify-content: flex-start;
}
.body{
  width: 1200px;
  margin: 0 auto;
  height: max-content;
}
.tab{
  display: flex;
  justify-content: space-around;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  margin-top: 100px;
}
 .tab .tabList img{
   width: 140px;
   height: 140px;
 }
 .tab .tabList .text{
   margin-top: 10px;
 }
</style>



// WEBPACK FOOTER //
// src/view/index.vue